
<expandable-textarea v-if="showTextArea" ref="input" :value="localValue" @input="formatInput" :disabled="disabled"
          :class="commonEntriesPropertiesCssClasses" v-tooltip.wrap="tooltipIfDisabled" v-bind="$attrs"></expandable-textarea>

<security-mask
  v-else-if="securityMaskingEnabled"
  :masked-values="securityMaskedValues"
  :class="commonEntriesPropertiesCssClasses"
  v-tooltip.wrap="tooltipIfDisabled"
  v-bind="$attrs"
></security-mask>

<multi-input v-else-if="formatAsPercentage" role="row" v-tooltip.wrap="tooltipIfDisabled">
  <div class="column" role="cell">
    <input
        ref="input"
        :value="percentageInputValue"
        v-bind="{ ...$attrs, type: inputType }"
        :disabled="disabled"
        :class="commonEntriesPropertiesCssClasses"
    >
  </div>

  <suffix role="cell">
    <p>%</p>
  </suffix>
</multi-input>

<input v-else ref="input" :value="localValue" v-bind="{ ...$attrs, type: inputType }" @input="formatInput" :disabled="disabled"
       :class="commonEntriesPropertiesCssClasses" v-tooltip.wrap="tooltipIfDisabled">
